import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { state, style, transition, trigger, useAnimation } from '@angular/animations';
import { fadeIn, fadeOut } from '../../animations/crossFade';
import { LoadingService } from '../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sigecom-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  animations: [
    trigger('EnterLeave', [
      state('flyIn', style({ transform: 'translateY(0)' })),
      transition(':enter', [useAnimation(fadeIn)]),
      transition(':leave', [useAnimation(fadeOut)]),
    ]),
  ],
  host: { class: 'block' },
})
export class LoadingComponent implements OnInit, OnDestroy {
  public active = false;
  private loadingSub?: Subscription;

  constructor(private loadingService: LoadingService) {}

  @HostListener('wheel', ['$event'])
  @HostListener('touchmove', ['$event'])
  public onScroll(event: Event): void {
    if (this.active && event.cancelable) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event'])
  public onKeydown(event: KeyboardEvent): void {
    if (
      this.active &&
      ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key) &&
      event.cancelable
    ) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    this.loadingSub = this.loadingService.isActive.subscribe((active) => (this.active = active));
  }

  ngOnDestroy(): void {
    this.loadingSub?.unsubscribe();
  }
}
